import React from 'react';
import { IAttachment } from '../../types';
import { classes } from '../../../Components/Modals/styles';
import { Box } from '@mui/material';
import { useDragScroll } from '../../../hooks';
import { ReactDOMAttributes } from '@use-gesture/react/dist/declarations/src/types';

export default function ImagePreview({
  isLoadingPreview,
  onPinchHandler,
  selectedAttachment,
  setIsLoadingPreview,
  zoom,
  assetUrl,
  onImageLoad
}: {
  isLoadingPreview: boolean;
  onPinchHandler: (...args: unknown[]) => ReactDOMAttributes;
  selectedAttachment: IAttachment;
  setIsLoadingPreview: React.Dispatch<React.SetStateAction<boolean>>;
  zoom: number;
  assetUrl?: string;
  onImageLoad?: (naturalWidth: number) => void;
}) {
  const [scrollRef] = useDragScroll();
  const BASE_URL = window.location.origin;
  const imageUrl = assetUrl || `${BASE_URL}/admin/assets/${selectedAttachment.id}`;

  const handleImageLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
    setIsLoadingPreview(false);
    if (onImageLoad && event.currentTarget.naturalWidth) {
      onImageLoad(event.currentTarget.naturalWidth);
    }
  };

  return (
    <Box
      ref={scrollRef}
      sx={{
        ...classes.imagePreviewContainer,
        WebkitOverflowScrolling: 'touch',
        touchAction: 'pan-x pan-y pinch-zoom',
        overflow: 'auto',
        width: '100%',
        height: '100%',
        maxHeight: '100%'
      }}
      {...onPinchHandler()}
    >
      <Box
        component="img"
        alt={selectedAttachment.attached_file_name}
        draggable={false}
        onLoad={handleImageLoad}
        src={imageUrl}
        sx={{
          ...(classes.imagePreview as React.CSSProperties),
          opacity: isLoadingPreview ? 0 : 1,
          transform: `scale(${zoom})`,
          transformOrigin: '0 0'
        }}
      />
    </Box>
  );
}
